const QUERY_CURRENT_CUSTOMER = `
query WebCurrentCustomer($expired_coupons_filter: PromoCodeFilter) {
  me {
    avatar_url
    encrypt_customer
    id
    first_name
    nickname
    roles {
      type
    }
    activities
    display_cart_entry
    finished_onboarding_questions_v2
    first_delivered_tote
    locked_tote_count
    registered_at
    first_subscribed_at
    customer_photo_incentive_detail {
      link_url
      incentive_hint
    }
    in_first_month_and_monthly_subscriber
    jd_credit_score {
      score
      id
      credit_rank
      name
    }
    credit_account {
      balance
    }
    customer_photo {
      featured_count
      liked_count
      customer_photo_count
    }
    referral_banner {
      lock_banner_url
      lock_banner_image
      referral_program_jump_url
      referral_program_banner_url
      referred_program_entry_banner_url
    }
    perfect_closet_stats {
      accessory_count
      clothing_count
      product_count
    }
    free_service(with_contract: true) {
      state
      can_apply_refund {
        errors {
          error_code
          message
        }
        success
      }
      account_entrance
      display_guide_in_product_page
      free_service_type {
        id
        name
        clothing_count
      }
    }
    valid_coupons {
      slot_count
      customer_coupon_id
      expired_at
      rules
      status
      sub_title
      title
      type
      valid_days
    }
    expired_coupons(filter: $expired_coupons_filter) {
      customer_coupon_id
      slot_count
      expired_at
      rules
      status
      sub_title
      title
      type
      valid_days
    }
    used_coupons {
      applied_at
      slot_count
      customer_coupon_id
      expired_at
      rules
      status
      sub_title
      title
      type
      valid_days
    }
    can_view_newest_products
    enable_payment_contract {
      id
      can_disable
    }
    available_purchase_credit {
      amount
      
    }
    time_cash_transactions {
      amount
      created_at
      id
      income
      transaction_type
      updated_at
    }
    referral_url
    expired_promo_codes {
      admin_note
      code
      description
      discount_amount
      expiration_date
      explainer
      is_referral
      status
      rules
      title
      tote_purchase_credit
      type
      condition_display
      mini_purchase_amount
    }
    used_promo_codes(type: All) {
      used_at
      admin_note
      code
      description
      discount_amount
      expiration_date
      explainer
      is_referral
      status
      rules
      title
      tote_purchase_credit
      type
      condition_display
      mini_purchase_amount
    }
    valid_promo_codes(type: All) {
      admin_note
      code
      description
      discount_amount
      expiration_date
      explainer
      is_referral
      status
      rules
      title
      tote_purchase_credit
      type
      condition_display
      mini_purchase_amount
      subscription_type_ids
    }
    payment_methods {
      id
      payment_gateway
    }
    credit_scores {
      id
      telephone
      score
    }
    closet(filters: {per_page: 5000, sort: closet}) {
      id
    }
    shipping_address {
      address_1
      address_2
      city
      company
      country
      customer_id
      district
      full_name
      id
      state
      telephone
      verified
      zip_code
    }
    email
    telephone
    simple_telephone
    tote_cart {
      id
        state
        nth_tote        
        max_clothing_count
        max_accessory_count
        clothing_bonus_slots_sum
        accessory_bonus_slots_sum
        express_fulfillment_center_config {
          open_change_express
          popup_change_express_banner_url
          tips
        }
        accessory_items {
          ...toteCartItemFields
        }
        clothing_items {
          ...toteCartItemFields
        }
        premium_clothing_slot_count
        premium_accessory_slot_count
        premium_service {
          max_purchase_clothing_slot
          max_purchase_accessory_slot
          clothing_slot_price
          accessory_slot_price
          origin_clothing_slot_price
          origin_accessory_slot_price
        }
        has_replaced_product
        display_more_product_entry
        with_free_service
        used_free_service
        disable_free_service
        display_free_service_banner
        disable_coupon
        accessory_customer_coupon {
          customer_coupon_id
          slot_count
        }
        clothing_customer_coupon {
          customer_coupon_id
          slot_count
        }
        onboarding
        tote_cart_bottom_tips
    }
    attribute_preferences {
      name
    }
    active_referral_program {
      recipient_amount
      sender_amount
    }
    style {
      constellation
      age_range
      bust_size_number
      shoulder_size
      birthday
      bra_size
      brand
      created_at
      cup_size
      customer_id
      dress_size
      height_inches
      hip_size
      hip_size_inches
      id
      inseam
      jean_size
      mom
      marital_status
      occupation
      pant_size
      shape
      skirt_size
      social_focus
      thigh_size
      top_fit
      top_size
      tummy_focus
      updated_at
      waist_size
      weight
      work
      waist_shape
      belly_shape
      shoulder_shape
      skirt_habit
      jean_prefer
      jean_waist_fit
      jean_size_unknow
    }
    customer_product_filters {
      accessory_categories
      accessory_colors
      clothing_categories
      clothing_colors
      prints
    }
    subscription_fees_count
    subscription {
      id
      totes_left
      totes_left_tips
      on_hold
      promo_code
      hold_date
      status
      billing_date
      display_interval
      billing_date_extending
      tote_entry_state
      remain_additional_days
      contract_display {
        menu_display
        order_display
        tote_display
      }
      next_tote_status {
        message
        code
        final_code
        can_create_tote
      }
      auto_charge_management_page {
        new_subscription_type
        configuration_file_url
      }
      subscription_type {
        id
        interval
        internal_name
        display_name_v2
        clothing_count
        accessory_count
        occasion
        days_interval
        base_price
        original_price
        is_accessory_slot_giveaway
        auto_renew_price_per_month
        preview {
          auto_renew_discount
          cash_price
          final_price
          name
          expiration_date_tips
          promo_code_price
        }
        free_service_type {
          id
          name
          clothing_count
          free_service_type_config {
            popup_content {
              img_url
            }
          }
        }
      }
    }
  }
  salesman {
    balance
    has_pending_withdraw
    level
    registration_num
    state
    subscribed_customer_num
    crew_count
    unsettled_amount
    withdrawed_amount
    youzan_customer_num
  }
  web_page_url {
    salesman_detailed_rule
  }
}

fragment toteCartItemFields on ToteCartItem {
  id
  slot
  product {
    id
    type
    disabled
    swappable
    tote_slot
    catalogue_photos {
      medium_url
    }
    category_rule {
      slug
      swap_ban_threshold
    }
    category {
      name
      accessory
    }
  }
  product_size {
    id
    swappable
    size_abbreviation
    size {
      id
      name
    }
  }
}
`

const QUERY_LINKED_SERVICE = `
query LinkedService($type: String!) {
  linked_service(type: $type) {
    subscribe
    openid
    nickname
    sex
    city
    province
    country
    language
    headimgurl
    subscribe_time
    unionid
  }
}
`

const QUERY_SALESMAN_INFO = `
query WebSalesman {
  salesman {
      balance
      has_pending_withdraw
      level
      registration_num
      state
      subscribed_customer_num
      crew_count
      unsettled_amount
      withdrawed_amount
      youzan_customer_num    
  }
  web_page_url {
    salesman_detailed_rule
  }
}
`

const QUERY_CUSTOMER_RECALL_INFOMATION = `
query WebCustomerRecallInfomation {
  recall_topic {
    id
    products(filters: {per_page: 9, sort: season_and_in_stock_in_my_size_newest}) {
      id
      catalogue_photos(limit: 1) {
        medium_url
      }
    }
  }
  me {
    recall {
      expires_on
      charge_amount
      customer_recall_gifts {
        name
        price
      }
      subscription_type {
        id
        original_price
        display_name_v2
        interval
      }
    }
  }
}
`

const MUTATION_REDEEM_RECALL_PACKAGE = `
mutation WebRedeemRecallPackage {
  RedeemRecallPackage(input:{}) {
    redeem_success
	}
}`

const QUERY_RECALL_LANDING_PAGE = `
query QueryRallLandingPage {
  recall_landing_page {
    recall_landing_page_banner_group {
      id
      banners {
        id
        image_url
      }
    }
    recall {
      expires_on
      charge_amount
      customer_recall_gifts {
        name
        price
      }
      subscription_type {
        id
        original_price
        display_name_v2
        interval
      }
    }
    perfect_products {
      id
       full_price
        member_price
      catalogue_photos(limit: 1) {
        id
        full_url
        giant_url
      }
    }
  }
}
`

export default {
  QUERY_SALESMAN_INFO,
  QUERY_LINKED_SERVICE,
  QUERY_CURRENT_CUSTOMER,
  QUERY_CUSTOMER_RECALL_INFOMATION,
  MUTATION_REDEEM_RECALL_PACKAGE,
  QUERY_RECALL_LANDING_PAGE
}
